export const prettyPrintJsonAsYamlList = (jsonObj: any, indent = 0) => {
  if (typeof jsonObj !== "object" || jsonObj === null) {
    throw new Error("Input is not a valid JSON object");
  }
  let yaml: string = "";
  const space: string = " ".repeat(indent);

  for (const key in jsonObj) {
    if (jsonObj.hasOwnProperty(key)) {
      const value = jsonObj[key];

      if (Array.isArray(value)) {
        yaml += `${space}${key}:\n`;

        for (const item of value) {
          if (typeof item === "object") {
            yaml += `${space}- \n${prettyPrintJsonAsYamlList(
              item,
              indent + 2
            )}`;
          } else {
            yaml += `${space}- ${item}\n`;
          }
        }
      } else if (typeof value === "object" && value !== null) {
        yaml += `${space}${key}:\n${prettyPrintJsonAsYamlList(
          value,
          indent + 2
        )}`;
      } else {
        yaml += `${space}${key}: ${value}\n`;
      }
    }
  }
  return yaml;
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/utils/prettyPrintJsonAsYamlList.ts